<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(
    :title="$t('digitalInput.title')"
    left-arrow
    @click-left="close"
    @click-right="checkForm")
    van-icon(name="save" slot="right")

  .main.addUnit__protocol
    van-cell-group.addUnit__popup__cell-group
      van-cell.van-cell--value-select(
        :title="$t('digitalInput.title')"
        :value="enable"
        @click="openSetEnable(enable)")

      van-cell.van-cell--value-select(
        :title="$t('digitalInput.configuration')"
        :value="nc"
        @click="openSetNc(nc)")

      van-cell.van-cell--value-select(
        :title="$t('digitalInput.offDelay')"
        :value="offdelay"
        @click="openSetOnOffDelay(offdelay, 'offDelay')")

      van-cell.van-cell--value-select(
        :title="$t('digitalInput.onDelay')"
        :value="ondelay"
        @click="openSetOnOffDelay(ondelay, 'onDelay')")
</template>

<script>
import BluetoothService from '@/services/bluetooth.service';
import { getErrorId } from '@/services/error.service';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      enable: '',
      nc: '',
      offdelay: null,
      ondelay: null,
      enableOptions: [
        { text: this.$i18n.t('digitalInput.disabled'), value: 0 },
        {
          text:
            this.appName === 'dknna'
              ? this.$i18n.t('digitalInput.enabledStatus')
              : this.$i18n.t('digitalInput.enabledStatusOld'),
          value: 1,
        },
        {
          text:
            this.appName === 'dknna'
              ? this.$i18n.t('digitalInput.enabledFlank')
              : this.$i18n.t('digitalInput.enabledFlankOld'),
          value: 2,
        },
      ],
      ncOptions: [
        { text: this.$i18n.t('digitalInput.nOpened'), value: 0 },
        { text: this.$i18n.t('digitalInput.nClosed'), value: 1 },
      ],
      onDelayOptions: [],
      offDelayOptions: [],
    };
  },

  methods: {
    /**
     * Devuelve el texto de la Entrada Digital
     */
    getEnableText(value) {
      const option = this.enableOptions.find(item => item.value === value);
      return option.text;
    },

    /**
     * Devuelve el valor de la Entrada Digital
     */
    getEnableValue(text) {
      const option = this.enableOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Devuelve el texto de la configuracion de la Entrada Digital
     */
    getNcText(value) {
      const option = this.ncOptions.find(item => item.value === value);
      return option.text;
    },

    /**
     * Devuelve el valor de la configuracion de la Entrada Digital
     */
    getNcValue(text) {
      const option = this.ncOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Devuelve el texto del tiempo de encendido/apagado de la Entrada Digital
     */
    getOnOffDelayText(value, type) {
      if (value) {
        value /= 60;
      }
      let option;
      if (type === 'onDelay') {
        option = this.onDelayOptions.find(item => item.value === value);
      } else {
        option = this.offDelayOptions.find(item => item.value === value);
      }
      // Si no hay valor definido en off delay, tomo el primero del array de opciones
      if (option === undefined) {
        option = this.offDelayOptions[0];
      }
      return option.text;
    },

    /**
     * Devuelve el valor del tiempo de encendido/apagado de la Entrada Digital
     */
    getOnOffDelayValue(text, type) {
      let option;
      if (type === 'onDelay') {
        option = this.onDelayOptions.find(item => item.text === text);
      } else {
        option = this.offDelayOptions.find(item => item.text === text);
      }
      if (option === undefined) {
        // Si no hay valor definido en off delay, tomo el primero del array de opciones
        option = this.offDelayOptions[0];
      }
      return option.value;
    },

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saveDigitalInput();
        }
      });
    },

    /**
     * Muestra el selector de la Entrada Digital
     */
    openSetEnable(value) {
      const configAlgortihm = {
        title: this.$i18n.t('digitalInput.title'),
        items: [[this.enableOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configAlgortihm, result => {
        this.enable = this.enableOptions[result[0].index].text;
      });
    },

    /**
     * Muestra el selector de la configuración de la Entrada Digital
     */
    openSetNc(value) {
      const configNc = {
        title: this.$i18n.t('digitalInput.configuration'),
        items: [[this.ncOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configNc, result => {
        this.nc = this.ncOptions[result[0].index].text;
      });
    },

    /**
     * Muestra el selector del apagado/encendido de la Entrada Digital
     */
    openSetOnOffDelay(value, type) {
      let onOffOptions = [];
      let title;

      if (type === 'onDelay') {
        title = this.$i18n.t('digitalInput.onDelay');
        onOffOptions = this.onDelayOptions;
      } else if (type === 'offDelay') {
        onOffOptions = this.onDelayOptions.slice(1, 31);
        title = this.$i18n.t('digitalInput.offDelay');
      }

      const itemsOnOff = [[onOffOptions]];

      const configDelay = {
        title,
        items: itemsOnOff,
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configDelay, result => {
        if (configDelay.title === this.$i18n.t('digitalInput.onDelay')) {
          this.ondelay = onOffOptions[result[0].index].text;
        } else if (configDelay.title === this.$i18n.t('digitalInput.offDelay')) {
          this.offdelay = onOffOptions[result[0].index].text;
        }
      });
    },

    /**
     * Guarda los datos
     */
    async saveDigitalInput() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.isLoading = true;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Preparo los datos
        const data = {};
        data.t1t2_enable = this.getEnableValue(this.enable);
        data.t1t2_nc = this.getNcValue(this.nc);
        // covierto de minutos en segudos * 60
        data.t1t2_offdelay = this.getOnOffDelayValue(this.offdelay, 'offDelay') * 60;
        data.t1t2_ondelay = this.getOnOffDelayValue(this.ondelay, 'onDelay') * 60;

        console.log(data);

        // Realizo la petición
        const dataResult = await BluetoothService.setDeviceParam(
          this.device.id,
          JSON.stringify(data)
        );

        // Set values in the model device
        this.device.t1t2_enable = dataResult.params.t1t2_enable;
        this.device.t1t2_nc = dataResult.params.t1t2_nc;
        this.device.t1t2_offdelay = dataResult.params.t1t2_offdelay;
        this.device.t1t2_ondelay = dataResult.params.t1t2_ondelay;

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('digitalInput.success'),
        });
        console.log('result: ', dataResult);
        this.close(dataResult.params);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('digitalInput.error') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cierra este componente
     */
    close(data) {
      this.$emit('close', data);
    },
  },

  created() {
    console.log('this: ', this);
    this.enable = this.getEnableText(this.device.t1t2_enable);
    this.nc = this.getNcText(this.device.t1t2_nc);
    this.onDelayOptions = [{ text: this.$i18n.t('digitalInput.disabled'), value: 0 }];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= 30; i++) {
      this.onDelayOptions.push({ text: String(i), value: i });
      this.offDelayOptions.push({ text: String(i), value: i });
    }
    this.offdelay = this.getOnOffDelayText(this.device.t1t2_offdelay, 'offDelay');
    this.ondelay = this.getOnOffDelayText(this.device.t1t2_ondelay, 'onDelay');
  },
};
</script>
